import React from 'react'
import { useNavigate } from 'react-router-dom'
import ProjectImg1 from '../assets/images/projects/projects1.jpg'
import ProjectImg2 from '../assets/images/projects/projects2.jpg'
import ProjectImg3 from '../assets/images/projects/projects3.jpg'
import ProjectImg4 from '../assets/images/projects/projects4.jpg'
import ProjectImg5 from '../assets/images/projects/projects5.jpg'
import ProjectImg6 from '../assets/images/projects/projects6.jpg'
import ProjectImg7 from '../assets/images/projects/projects7.jpg'
import ProjectImg8 from '../assets/images/projects/projects8.jpg'
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import ClientsSaySlider from '../component/ClientsSaySlider'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'

const Project2 = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Project Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="project-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Projects</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/Project2")}>Projects</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/Project2")}>Projects 2</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Project Section Two ===================================== --> */}
            <section className="about-section-two overflow-hidden">
                <div className="container">
                    <h2 className=" section-heading-text latestProjects-heading" data-aos="fade-up"><span>Content Writing </span>
                        Projects</h2>
                    <p className="section-sub-text pharetra urna" data-aos="fade-up">Hendrerit facilisi habitasse arcu urna
                        bibendum. Cursus in mattis nunc pretium amet dignissim.</p>
                    <div className="row project-page2-row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-right">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg1} alt="projects1" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">01</h3>
                                    <h3 className="project-box-main-text">Homely Real Estate</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-left">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg2} alt="projects2" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">02</h3>
                                    <h3 className="project-box-main-text">Crypti App</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-right">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails3")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg3} alt="projects3" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">03</h3>
                                    <h3 className="project-box-main-text">24Times News</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-left">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg4} alt="projects4" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">04</h3>
                                    <h3 className="project-box-main-text">Mobiza Mobile</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-right">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg5} alt="projects5" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">05</h3>
                                    <h3 className="project-box-main-text">Jecky Grocery</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-left">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails3")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg6} alt="projects6" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">06</h3>
                                    <h3 className="project-box-main-text">Technical Writing</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-right">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails1")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg7} alt="projects7" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">07</h3>
                                    <h3 className="project-box-main-text">Blogging SEO</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6" data-aos="fade-left">
                            <div className="project-box-main" onClick={() => navigate("/ProjectDetails2")}>
                                <div className="overflow-hidden">
                                    <img className="project-box-main-img" src={ProjectImg8} alt="projects8" />
                                </div>
                                <div className="project-num-name">
                                    <h3 className="numbers-projects">08</h3>
                                    <h3 className="project-box-main-text">Real Estate</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ClientsSaySlider />
            <LatestBlog />
            <Footer />
        </>
    )
}

export default Project2